<template>
  <div>
    <div v-if="app_mobile_view == true">
      <div class="uk-margin"></div>
    </div>
    <div v-if="app_mobile_view == false">
      <nav class="uk-container uk-navbar">
        <div class="uk-navbar-left">
          <ul class="uk-navbar-nav">
            <li class="uk-active">
              <h2
                class="uk-margin-small-left uk-margin-auto-vertical main-title"
              >
                {{ $store.getters.appMainTitle }}
              </h2>
              <div
                class="uk-margin-small-left uk-margin-auto-vertical sub-title uk-hidden@m uk-column-1-3"
              >
                <div>Scarica l' App!!</div>
                <div>
                  <a
                    href="itms-apps://itunes.apple.com/app/id1021218602"
                    target="_blank"
                    ><img src="@/assets/applestore.png"
                  /></a>
                </div>
                <div>
                  <a
                    href="https://play.google.com/store/apps/details?id=com.greengobus.greengobus"
                    target="_blank"
                    ><img src="@/assets/googleplay.png"
                  /></a>
                </div>
              </div>
            </li>
          </ul>
        </div>
        <div class="uk-navbar-right">
          <ul class="uk-navbar-nav uk-visible@s">
            <li v-for="(mi, index) in menuitems">
              <router-link
                v-if="mi.key_code !== 'home'"
                :to="'/' + mi.key_code"
                >{{ mi.title }}</router-link
              >

              <router-link v-if="mi.key_code === 'home'" :to="'/'">{{
                mi.title
              }}</router-link>
            </li>
            <!--<li class="uk-active"><a uk-toggle="target: #main-modal-maps">Selezione Mappa</a></li>-->
          </ul>
          <a
            href="#"
            class="uk-navbar-toggle uk-hidden@s"
            uk-navbar-toggle-icon
            uk-toggle="target: #sidenav"
          ></a>
        </div>
      </nav>

      <div id="sidenav" uk-offcanvas="flip: true" class="uk-offcanvas">
        <div class="uk-offcanvas-bar">
          <ul class="uk-nav">
            <li v-for="(mi, index) in menuitems">
              <router-link :to="mi.key_code">{{ mi.title }}</router-link>
            </li>
            <!--<li class="uk-active"><a uk-toggle="target: #main-modal-maps">Selezione Mappa</a></li>-->
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.uk-navbar-toggle {
  width: 50px;
}
</style>

<script>
import axios from "axios";
import SyncLoader from "vue-spinner/src/SyncLoader.vue";
import { settings } from "@/settings";

let API_SERVER = settings.API_SERVER;

export default {
  name: "HeaderView",
  data: function() {
    return {
      app_mobile_view: false,
      menuitems: {},
      debug: false,
    };
  },
  methods: {
    getSettings() {
      axios.get(API_SERVER + "/_/items/web_settings").then((response) => {
        if (response.data.data.length > 0) {
          this.settings = response.data.data[0];
        }
      });
    },
    getMenuItems() {
      let status_filter = "published";
      if (this.debug) {
        status_filter += ",debug";
      }

      axios
        .get(API_SERVER + "/_/items/pages?status=" + status_filter)
        .then((response) => {
          if (response.data.data.length > 0) {
            this.menuitems = response.data.data;
            this.menuitems.push({ key_code: "news", title: "News" });
          }
        });
    },
    checkQueryStringParams() {
      if (this.$route.query.nohead == "1" && this.$route.query.mobile == "1") {
        this.app_mobile_view = true;
      }
    },
  },
  created() {
    if (this.$route.query.debug == "1234") {
      this.debug = true;
    }

    this.checkQueryStringParams();

    this.getSettings();
    this.getMenuItems();
  },
};
</script>
